import React from 'react';

import classes from './Expander.module.scss';
import FAIcon from "../UI/Icons/FAIcon";



class Expander extends React.Component {

    constructor(props) {
        super(props);

        this.panelRef = React.createRef();

        this.timer = null;
    }


    state = {
        active:false,
        scrollHeight:1000
    };



    componentDidMount(){

        //
        // If the images are not fully loaded the scrollHeight will be off.
        // This timer will check periodically for the max scrollHeight.
        //
        this.timer = setInterval(()=>{

            if( this.panelRef.current && this.panelRef.current.scrollHeight ){

                // console.log("Intervale", this.panelRef.current.scrollHeight);

                this.setState({
                    scrollHeight:this.panelRef.current.scrollHeight
                })
            }

        }, 2000);



        if(this.props.active){
            //
            // A timer is required to let the screen fill.
            // Otherwise a small panel may be created.
            //
            // this.timer =setTimeout(()=>{
            //     this.setState({
            //         active: true
            //     })
            //
            // }, 1000)

            this.setState({
                active: true
            });
        }
    }


    componentWillUnmount() {

        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        }
    }




    toggle = () => {

        this.setState( (prevState) => {
            return {
                active:!prevState.active
            }
        })
    };



    render() {

        const style = {};

        if( this.panelRef.current ){

            const scrollHeight = (this.state.scrollHeight) ? this.state.scrollHeight: this.panelRef.current.scrollHeight;

             style.maxHeight = (this.state.active ? (scrollHeight+500) + "px" : null)
        } else {
            style.maxHeight = null;
        }


        // let img = null;
        // if( this.state.active ){
        //     img = require("../../assets/images/icons/ico-minus.svg").default;
        // } else {
        //     img = require("../../assets/images/icons/ico-plus.svg").default;
        // }

        let icon = null;
        if( this.state.active ){
            icon = "minus";
        } else {
            icon = "plus";
        }


        return (
            <div className={this.props.outerClasses?this.props.outerClasses:""}>
                <div className={classes.expander +" " + (this.state.active?classes.active:"") } onClick={this.toggle}>

                    <h4 className={" " + classes.title}>{this.props.title}</h4>
                    {/*<img src={img} alt="" />*/}
                    <FAIcon className={"px-2"} icon={icon}/>

                </div>
                <div ref={this.panelRef} className={classes.panel}  style={style}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Expander
